import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Gradient-gray-line",
  "use": "icon-Gradient-gray-line-usage",
  "viewBox": "0 0 413 2",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 413 2\" id=\"icon-Gradient-gray-line\"><path stroke=\"url(#icon-Gradient-gray-line_a)\" d=\"M0 1h412.5\" /><defs><linearGradient id=\"icon-Gradient-gray-line_a\" x1=\"-68.919\" y1=\"1.501\" x2=\"412.5\" y2=\"1.502\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#E7EBF3\" stop-opacity=\"0\" /><stop offset=\".998\" stop-color=\"#C2CBDC\" /></linearGradient></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol